import { render, staticRenderFns } from "./MaterialActivities.vue?vue&type=template&id=7b59d9a9"
import script from "./MaterialActivities.vue?vue&type=script&lang=js"
export * from "./MaterialActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports